import React from 'react';
import { Field, destroy, initialize } from 'redux-form/immutable';
import Typography from '@material-ui/core/Typography';
import RenderTextField from 'components/Form/TextField';
import RenderCheckField from 'components/Form/CheckField';
import RenderSelectField from 'components/Form/SelectField';
import Grid from '@material-ui/core/Grid';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';

import { SUCCESS, REQUEST } from 'helpers/constants';
import { getUser, saveUser } from 'reducers/user';
import { validate } from 'helpers/utils';
import Confirm from 'components/Confirm';
import binder from 'helpers/binder';
import BaseContainer from 'components/BaseContainer';
import store from 'helpers/localStore';

import styles from './EditStyles';

const nameForm = 'userEdit';

class UserEdit extends BaseContainer {
  componentWillMount = () => {
    const { actions, match: { params } } = this.props;
    actions.getUser(params.userId);
  }

  componentWillReceiveProps = (nextProps) => {
    const {
      stateSecond, dispatch, match, history, stateUser, initialValues,
    } = this.props;
    const { stateSecond: stateSecondNew } = nextProps;
    const statusSecond = (stateSecond && stateSecond.get('status')) || false;
    const statusSecondNew = (stateSecondNew && stateSecondNew.get('status')) || false;
    if (statusSecond === REQUEST && statusSecondNew === SUCCESS) {
      if (match.params.userId === 'new') {
        history.replace(`${match.url.replace('new', stateSecondNew.getIn(['data', '_id']))}`);
      }
      if (stateUser.get('_id') === initialValues.get('_id')) {
        store.delete('token');
        document.location.href = '/login';
        return;
      }
      dispatch(initialize(nameForm, stateSecondNew.get('data')));
    }
  }

  componentWillUnmount = () => {
    const { dispatch, actions } = this.props;
    dispatch(destroy(nameForm));
    actions.getUser({ initialize: true });
  }

  handleShowMessage = params => (
    Confirm(params.message, {
      title: params.title,
      hideCancel: true,
    })
  );

  handleSubmit = (values) => {
    const { actions } = this.props;
    actions.saveUser(values.toJS());
  }

  toRenderTitlePage = () => 'Edición de usuarios';

  toRender() {
    const {
      classes, stateApp, dirty, handleSubmit,
    } = this.props;
    return (
      <React.Fragment>
        <Grid
          item
          container
          alignItems="center"
          wrap="nowrap"
          justify="space-between"
          spacing={0}
          className={classes.hdRoot}
        >
          <IconButton
            aria-label="Return"
            className={classes.backIcon}
            component={Link}
            to="/users"
            edge="start"
            title="Volver a lista de formularios"
          >
            <ArrowBackIcon />
          </IconButton>

          <Button
            variant="contained"
            color="primary"
            disabled={!dirty}
            onClick={() => handleSubmit(this.handleSubmit)()}
          >
            <SaveIcon className={classes.hdLeftIcon} />
            Guardar
          </Button>
        </Grid>
        <Grid
          container
          justify="center"
          alignContent="flex-start"
          className={classes.bdWrap}
          id="bodyForm"
        >
          <div className={classes.bdInner}>
            <Grid container spacing={2}>
              <Grid item xs={12} className={classes.gridItemField}>
                <Typography variant="button" display="block" style={{ marginTop: '24px' }}>
                  Datos personales
                </Typography>
              </Grid>
              <Grid item xs={6} className={classes.gridItemField}>
                <Field
                  label="Nombres"
                  name="names"
                  margin="normal"
                  fullWidth
                  component={RenderTextField}
                />
              </Grid>
              <Grid item xs={6} className={classes.gridItemField}>
                <Field
                  label="Apellidos"
                  name="surnames"
                  margin="normal"
                  fullWidth
                  component={RenderTextField}
                />
              </Grid>
              <Grid item xs={6} className={classes.gridItemField}>
                <Field
                  label="Rol"
                  name="role"
                  margin="normal"
                  fullWidth
                  renderValue={input => input.value.get('label')}
                  componentProps={{
                    isSearchable: false,
                    options: stateApp.getIn(['types', 'roles']),
                    noOptionsMessage: () => 'Vacío',
                  }}
                  component={RenderSelectField}
                />
              </Grid>
              <Grid item xs={6} className={classes.gridItemField}>
                <Field
                  label="Estaciones"
                  name="stations"
                  margin="normal"
                  fullWidth
                  renderValue={input => input.value.get('label')}
                  componentProps={{
                    isSearchable: false,
                    isMulti: true,
                    options: (stateApp.getIn(['stations']).toJS().map(item => ({ label: item.name, value: item.id }))),
                    noOptionsMessage: () => 'Vacío',
                  }}
                  component={RenderSelectField}
                />
              </Grid>
            </Grid>
            <Grid container className={classes.bdInner} spacing={2}>
              <Grid item xs={12} className={classes.gridItemField}>
                <Typography variant="button" display="block" gutterBottom>
                  Datos de acceso
                </Typography>
              </Grid>
              <Grid item xs={6} className={classes.gridItemField}>
                <Field
                  label="Nombre de usuario (e-mail)"
                  name="username"
                  margin="normal"
                  fullWidth
                  component={RenderTextField}
                />
              </Grid>
              <Grid item xs={6} className={classes.gridItemField}>
                <Field
                  label="Contraseña"
                  placeholder="Dejar en blanco si no desea cambiar"
                  name="password"
                  margin="normal"
                  type="password"
                  fullWidth
                  component={RenderTextField}
                />
              </Grid>
            </Grid>
            
            <Grid item xs={4} className={classes.gridItemField}>
              <Field
                label="Activo"
                name="isActive"
                component={RenderCheckField}
              />
            </Grid>
          
          </div>
        </Grid>
      </React.Fragment>
    );
  }
}

export default binder({
  styles,
  stylesName: nameForm,
  reduxForm: {
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    form: nameForm,
    validate: (values, props) => {
      const { match } = props;
      let errors = {};
      errors = validate.isEmpty('names,email,username,role,stations', values, errors);
      if (match.params.userId && match.params.userId === 'new') {
        if (!(values.get('password') || '').trim()) {
          errors.password = 'error';
        }
      }
      const email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
      if (!email.test((values.get('username') || '').toLowerCase())) {
        errors.username = 'error'
      }
      
      return errors;
    },
  },
  states: {
    stateMain: ['user', 'get'],
    stateSecond: ['user', 'save'],
    stateApp: ['app', 'resources', 'data'],
    initialValues: ['user', 'get', 'data'],
    stateUser: ['user', 'login', 'data'],
  },
  actions: { getUser, saveUser },
  component: UserEdit,
});
